<template>
  <div class="container-home">
    <story-component :memberKey="memberKey"></story-component>
    <page-footer :performKey="memberKey"></page-footer>
  </div>
</template>

<script>
import PageFooter from "@/components/PageFooter";
import StoryComponent from "@/components/story/StoryComponent";

export default {
  name: "Story",
  mixins: [],
  components: {StoryComponent, PageFooter},
  inject: [],
  provide() {
    return {}
  },
  props: {},
  data() {
    return {
      memberKey: this.$route.params.idx,
    }
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {},
  watch: {},
}
</script>

<style scoped>

</style>
